import type { UpdateNotificationReadStatus200SourceSourceUser } from './updateNotificationReadStatus200SourceSourceUser';

/**
 * 알림 소스 정보
 */
export type UpdateNotificationReadStatus200Source = {
  /** 알림을 발생시킨 사용자 정보 */
  sourceUser?: UpdateNotificationReadStatus200SourceSourceUser;
  /** 알림을 발생시킨 사용자 ID */
  sourceUserId?: number;
};
